(function () {
  function cmp(a, b, dir) {
    var na = parseFloat(a), nb = parseFloat(b);
    var both = !isNaN(na) && !isNaN(nb) && /^[\s$]*[-\d.,]+/.test(a) && /^[\s$]*[-\d.,]+/.test(b);
    var r = both ? na - nb : String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
    return dir === 'desc' ? -r : r;
  }

  function sortTable(table) {
    var rows = Array.prototype.slice.call(table.querySelectorAll('.ptable__row'));
    if (!rows.length) return;
    rows.sort(function (x, y) {
      for (var i = 1; i <= 3; i++) {
        var a = x.dataset['s' + i] || '', b = y.dataset['s' + i] || '';
        if (a === '' && b === '') continue;
        var r = cmp(a, b, x.dataset['d' + i] || 'asc');
        if (r !== 0) return r;
      }
      return 0;
    });
    rows.forEach(function (r) { table.appendChild(r); });
  }

  function initSearch(root) {
    var input = root.querySelector('[data-table-search]');
    if (!input) return;
    var main = root.querySelector('.catalog__main') || root;
    var rows = Array.prototype.slice.call(main.querySelectorAll('.ptable__row'));
    var groups = Array.prototype.slice.call(main.querySelectorAll('.group'));
    var colls = Array.prototype.slice.call(main.querySelectorAll('.catalog__coll'));
    var count = root.querySelector('[data-match-count]');
    var empty = main.querySelector('[data-no-match]');

    rows.forEach(function (r) {
      var extra = [];
      r.querySelectorAll('[data-label]').forEach(function (c) {
        extra.push(c.getAttribute('data-label'));
      });
      var table = r.closest('.ptable');
      if (table) {
        table.querySelectorAll('.ptable__head > div').forEach(function (h) {
          extra.push(h.textContent);
        });
      }
      var group = r.closest('.group');
      if (group) {
        var head = group.querySelector('.group__head');
        if (head) extra.push(head.textContent);
      }
      r.dataset.haystack = ((r.textContent || '') + ' ' + extra.join(' '))
        .toLowerCase().replace(/\s+/g, ' ');
    });

    function apply() {
      var q = input.value.trim().toLowerCase(), shown = 0;
      var terms = q ? q.split(/\s+/) : [];
      rows.forEach(function (r) {
        var hay = r.dataset.haystack;
        var hit = terms.every(function (t) { return hay.indexOf(t) > -1; });
        r.style.display = hit ? '' : 'none';
        r.dataset.hit = hit ? '1' : '0';
        if (hit) shown++;
      });
      groups.forEach(function (g) {
        var any = g.querySelector('.ptable__row[data-hit="1"]');
        g.style.display = any ? '' : 'none';
        if (any && q) g.open = true;
      });
      colls.forEach(function (h) {
        var el = h.nextElementSibling, any = false;
        while (el && !el.classList.contains('catalog__coll')) {
          if (el.classList.contains('group') && el.style.display !== 'none') any = true;
          el = el.nextElementSibling;
        }
        h.style.display = any ? '' : 'none';
      });
      if (count) count.textContent = shown + (shown === 1 ? ' match' : ' matches');
      if (empty) empty.style.display = shown === 0 ? '' : 'none';
    }

    input.addEventListener('input', apply);
    root.querySelectorAll('[data-clear-search]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!input.value) return;
        e.preventDefault();
        input.value = '';
        apply();
      });
    });
    apply();
  }

  function initCarousel(root) {
    var slides = root.querySelectorAll('.carousel__slide');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function play() {
      if (root.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, (parseInt(root.dataset.interval, 10) || 5) * 1000);
    }
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
    if (next) next.addEventListener('click', function () { show(i + 1); play(); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    show(0);
    play();
  }

  function boot() {
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    document.querySelectorAll('.ptable[data-sortable]').forEach(sortTable);
    document.querySelectorAll('.catalog__main').forEach(function (m) { initSearch(m.parentNode || m); });
    var isM = window.matchMedia('(max-width:820px)');
    document.querySelectorAll('[data-fold-m]').forEach(function (d) {
      if (d.dataset.folded === '1') return;
      d.dataset.folded = '1';
      if (isM.matches) d.open = false;
      isM.addEventListener('change', function (e) { d.open = !e.matches; });
    });
    if (isM.matches) {
      document.querySelectorAll('.rail--cats[data-collapse-m] .cat[open]').forEach(function (d) { d.open = false; });
    }
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
